import { Link, useNavigate } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';
import { useState, useEffect } from 'react';
import uniImage from '../Assets/icon5.png'
export default function Header() {
  const [ mobileMenuOpen, setMobileMenuOpen ] = useState(false);
  const [ scrolled, setScrolled ] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Tutorials', path: '/tutorials' },
    { name: 'Privacy Policy', path: '/privacy' },
    { name: 'Download', path: '/download' },
    { name: 'Connect with Us', path: '/connect' },
    { name: 'Join the Team', path: '/join' },
    { name: 'Sign In', path: '/dashboard' },
  ];

  return (
    <header
      className={`sticky top-0 z-50 w-full bg-brand-yellow transition-all duration-300 ${scrolled ? 'shadow-lg' : 'shadow-md'
        }`}
    >
      <div className="container flex h-20 items-center justify-between">
        <Link to="/" className="flex items-center space-x-3 transition-transform hover:scale-105">
          <img
            src={uniImage}
            alt="UNILinkd Logo"
            className="h-12 w-auto"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden items-center space-x-2 md:flex">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="rounded-lg px-4 py-2 text-sm font-bold text-brand-black transition-all hover:bg-brand-white hover:shadow-md"
              activeProps={{
                className: 'bg-brand-white text-brand-black shadow-md',
              }}
            >
              {link.name}
            </Link>
          ))}
          <Button
            variant="default"
            size="default"
            className="ml-4 rounded-lg bg-brand-blue font-bold text-brand-white shadow-lg transition-all hover:scale-105 hover:shadow-xl"
            onClick={() => navigate({ to: '/prototypes' })}
          >
            View Prototypes
          </Button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X className="h-7 w-7 text-brand-black" /> : <Menu className="h-7 w-7 text-brand-black" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="bg-brand-yellow shadow-lg md:hidden">
          <nav className="container flex flex-col  space-y-2 py-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="rounded-lg px-4 py-3 text-sm font-bold text-brand-black transition-all hover:bg-brand-white hover:shadow-md"
                activeProps={{
                  className: 'bg-brand-white text-brand-black shadow-md',
                }}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <Button
              variant="default"
              size="default"
              className="mt-2 rounded-lg bg-brand-blue font-bold text-brand-white shadow-lg"
              onClick={() => {
                setMobileMenuOpen(false);
                navigate({ to: '/prototypes' });
              }}
            >
              View Prototypes
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
}
